import ECDN11Playback from '../../ecdn11/Playback';
import { DeliveryMode, Playback } from '../../common/constants';
import dispatchConnectionInfo, {
  CONNECTION_INFO_EVENT_TAGS
} from '../../ecdn11/dispatchConnectionInfo';

const { ECDN11, WEBRTC } = DeliveryMode;
const NOT_ENABLED = CONNECTION_INFO_EVENT_TAGS.NOT_ENABLED;

type Response = {
  playback: Playback;
  PlaybackModule?: typeof ECDN11Playback;
  reason?: 'no.p';
};

export default function getPlaybackModule(mode: DeliveryMode): Response {
  switch (mode) {
    case WEBRTC:
    case ECDN11:
      return {
        playback: mode === WEBRTC ? Playback.BBP : Playback.ECDN11,
        PlaybackModule: ECDN11Playback
      };
    default:
      dispatchConnectionInfo(WEBRTC, NOT_ENABLED);
      dispatchConnectionInfo(ECDN11, NOT_ENABLED);
      return { playback: Playback.CDN, reason: 'no.p' };
  }
}
